import { get, set } from "lodash";
import { saveAs } from "file-saver";
import moment from "moment";
import * as XLSX from "xlsx";

import { STORAGE_ITEMS } from "@config";

export const allowOnlyNumbers = e => {
  // allows numbers from keypad, number row
  const keyPadNumbers = e.keyCode > 95 && e.keyCode < 106;
  const numberRowNumbers = e.keyCode > 47 && e.keyCode < 58;
  // arrow keys, home, end, enter, shift
  const utilKeys =
    e.keyCode === 37 ||
    e.keyCode === 8 ||
    e.keyCode === 39 ||
    e.keyCode === 36 ||
    e.keyCode === 35 ||
    e.keyCode === 13 ||
    e.keyCode === 187 ||
    e.keyCode === 9;
  if (!(keyPadNumbers || numberRowNumbers || e.keyCode === 8 || utilKeys)) {
    e.preventDefault();
  }
};

export const strPadLeft = (string, pad, length) => {
  return (new Array(length + 1).join(pad) + string).slice(-length);
};

export const secondsToMinutesWithSeconds = totalSeconds => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds - minutes * 60;

  const finalTime = strPadLeft(minutes, "0", 2) + ":" + strPadLeft(seconds, "0", 2);
  return finalTime;
};

export const getFormattedLanguageFromStorage = () => {
  const language = localStorage.getItem(STORAGE_ITEMS.LANGUAGE);
  return language ? language.split("-")[0] : "lt";
};

export const removeFalsyValuesFromObj = (obj = {}) => {
  const objCopy = { ...obj };
  Object.keys(objCopy).forEach(key => {
    if (objCopy.hasOwnProperty(key) && !objCopy[key]) delete objCopy[key];
  });
  return objCopy;
};

export const updateArrElementById = (arr, newElement) => {
  if (!arr) return [];

  const arrClone = [...arr];
  const elementToEditIdx = arrClone.findIndex(el => el.id === newElement.id);
  if (elementToEditIdx >= 0) {
    arrClone.splice(elementToEditIdx, 1, { ...newElement });
  }
  return arrClone;
};

export const stepperFormValidationMapper = (values, validations) => {
  const errors = validations.reduce((formErrors, { field, validation, compareField }) => {
    const hasError = get(formErrors, field);
    if (hasError) return formErrors;

    const value = get(values, field);
    let validationError;

    if (compareField) {
      const compareFieldValue = get(values, compareField);
      validationError = validation(value, compareFieldValue);
    } else {
      validationError = validation(value);
    }

    if (validationError) {
      set(formErrors, field, validationError);
    }
    return formErrors;
  }, {});
  return { values, errors };
};

export const parsePhone = value => {
  if (!value) return value;
  const onlyNums = value.replace(/[^\d]/g, "");
  return `+${onlyNums}`;
};

export const writeExcelFile = ({ items, fileName, colWidths }) => {
  const fileDate = moment(new Date()).format("DD-MM-YYYY HH-mm-ss");
  const sheetName = `${fileName} ${fileDate}.xlsx`;
  const workBook = XLSX.utils.book_new();
  const workSheet = XLSX.utils.json_to_sheet(items, { header: false });
  workSheet["!cols"] = colWidths;
  XLSX.utils.book_append_sheet(workBook, workSheet, fileName);
  XLSX.writeFile(workBook, sheetName);
};

export const downloadFile = ({ fileId, fileName, url }) => {
  const oReq = new XMLHttpRequest();
  oReq.open("GET", `${url}/${fileId}`, true);
  oReq.responseType = "blob";
  // When the file request finishes
  // Is up to you, the configuration for error events etc.
  oReq.onload = () => {
    const file = new Blob([oReq.response], {
      type: oReq.response.type
    });
    // Generate file download directly in the browser !
    saveAs(file, fileName);
  };
  oReq.send();
}

export const b64DecodeUnicode = base64 => {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  const text = window.atob(base64);
  const length = text.length;
  const bytes = new Uint8Array(length);
  for (let i = 0; i < length; i++) {
    bytes[i] = text.charCodeAt(i);
  }
  const decoder = new TextDecoder(); // default is utf-8
  return decoder.decode(bytes);
};
